/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import Above from 'components/breakpoints/Above';
import AspectWrapper from 'components/wrappers/AspectWrapper';
import BackgroundSwitch from 'components/background/BackgroundSwitch';
import Below from 'components/breakpoints/Below';
import Breadcrumbs from 'components/Breadcrumbs';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import GiftCertificateContent from 'components/pages/checkout/GiftCertificateContent';
import { GiftCertificateProvider } from 'libs/GiftCertificate/GiftCertificateContext';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import ratios from 'config/theme/ratios';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

const GiftCertificate = ({ data }) => {
    const isAboveMd = useAboveBreakpoint('md');

    const { content, breadcrumbs, title } = data;
    const { background_media_flexible: background } = content;

    const transformedBackground = transformFlexibleBackground(background);
    const mobileBackground = transformedBackground.mobile || transformedBackground.desktop;
    const desktopBackground = transformedBackground.desktop || transformedBackground.mobile;

    return (
        <MaxWidthWrapper includeContentMargins>
            <Below breakpoint="md" render={() => <Breadcrumbs currentTitle={title} items={breadcrumbs} mb="16px" />} />
            <ColumnsLayout
                blocks={[
                    <AspectWrapper key="1" ratio={[ratios.vertical, null, ratios.verticalWide]}>
                        <BackgroundSwitch width="100%" background={isAboveMd ? desktopBackground : mobileBackground} />
                    </AspectWrapper>,
                    <div key="2">
                        <Above
                            breakpoint="md"
                            render={() => <Breadcrumbs currentTitle={title} items={breadcrumbs} my="24px" />}
                        />
                        <GiftCertificateProvider giftCertIdsFromCms={data.gift_certificate_setup.gift_certificates}>
                            <GiftCertificateContent data={data} />
                        </GiftCertificateProvider>
                    </div>,
                ]}
                columnSizes={[12, null, 6]}
                gutterHeight={0}
            />
        </MaxWidthWrapper>
    );
};

GiftCertificate.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        breadcrumbs: PropTypes.arrayOf(PropTypes.object),
        content: PropTypes.object,
    }),
};

GiftCertificate.defaultProps = {
    data: {
        content: {},
    },
};

export default GiftCertificate;
